import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export interface IPaymentResult {
    isOpenPopup: boolean,
    email: string,
    frameUrl?: string,
    payStatus?: number,
    queryAgreement?: string,
    isPayCardSuccess?: boolean,
    isBonusesSuccess?: boolean,
}

export type TSetPaymentResult = IAction<EPaymentActions.SET_PAYMENT_RESULT, IPaymentResult>

const setPaymentResult = (result: IPaymentResult): TSetPaymentResult => ({
    type: EPaymentActions.SET_PAYMENT_RESULT,
    payload: result,
});

export default setPaymentResult;
